export function canSwipeNail({view,tool,zoom,selectedLayer,layer,resize,multiSelect}) {
  // Picking resolves real paint, including transparent gaps between patterns.
  // Painted shapes drag immediately; only unpainted canvas can navigate.
  return view==='single'&&tool==='select'&&zoom<=1.001&&!resize&&!multiSelect&&!layer;
}

export function nailSwipeIntent(start,point) {
  const dx=Math.abs(point.x-start.x),dy=Math.abs(point.y-start.y);
  if(Math.hypot(dx,dy)<12)return null;
  return dx>dy*1.35?'horizontal':'vertical';
}

export function swipedFinger(index,start,point,intent) {
  const dx=point.x-start.x,dy=point.y-start.y;
  if(intent!=='horizontal'||Math.abs(dx)<42||Math.abs(dx)<Math.abs(dy)*1.35)return index;
  return (index+(dx<0?1:9))%10;
}

export function currentFingerSize(design,index) {
  if(design.size==='custom'){
    if(design.sizeMode==='per-finger')return design.fingerSizes?.[index]||'尺寸未设置';
    if(design.sizeMode==='tip-number')return design.tipNumbers?.[index]!=null?`${design.tipNumbers[index]} 号`:'尺寸未设置';
    return design.widths?.[index]!=null?`${design.widths[index]} mm`:'尺寸未设置';
  }
  return `${design.size} 码`;
}
